import styled from 'styled-components';
import {
    heading1Theme,
    heading2Theme,
    heading3Theme,
    heading4Theme,
    heading5Theme,
    heading6Theme,
    body1Theme,
    body2Theme,
    subtitle1Theme,
    subtitle2Theme,
    subtitle3Theme,
    captionTheme,
    overlineTheme,
    DarkClassName
} from '../theme/default-theme';
import { Emphasis, IEmphasisProps } from '@estee/elc-base-theme';

interface ITextProps {
    emphasis?: IEmphasisProps;
    darkTheme?: boolean;
}

const classes = (cls: string, props: ITextProps) =>
    `${cls} ${props.emphasis ? props.emphasis.className : Emphasis.high.className} ${
        props.darkTheme ? DarkClassName : ''
    }`.trim();

export const Heading1 = styled.h1.attrs<ITextProps>(props => ({
    className: classes('elc-heading--1', props)
}))`
    ${heading1Theme};
`;

export const Heading2 = styled.h2.attrs<ITextProps>(props => ({
    className: classes('elc-heading--2', props)
}))`
    ${heading2Theme};
`;

export const Heading3 = styled.h3.attrs<ITextProps>(props => ({
    className: classes('elc-heading--3', props)
}))`
    ${heading3Theme};
`;

export const Heading4 = styled.h4.attrs<ITextProps>(props => ({
    className: classes('elc-heading--4', props)
}))`
    ${heading4Theme};
`;

export const Heading5 = styled.h5.attrs<ITextProps>(props => ({
    className: classes('elc-heading--5', props)
}))`
    ${heading5Theme};
`;

export const Heading6 = styled.h6.attrs<ITextProps>(props => ({
    className: classes('elc-heading--6', props)
}))`
    ${heading6Theme};
`;

export const Body1 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-body--1', props)
}))`
    ${body1Theme};
`;

export const Body2 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-body--2', props)
}))`
    ${body2Theme};
`;

export const Subtitle1 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-subtitle--1', props)
}))`
    ${subtitle1Theme};
`;

export const Subtitle2 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-subtitle--2', props)
}))`
    ${subtitle2Theme};
`;

export const Subtitle3 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-subtitle--3', props)
}))`
    ${subtitle3Theme};
`;

export const Caption = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-caption', props)
}))`
    ${captionTheme};
`;

export const Overline = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-overline', props)
}))`
    ${overlineTheme};
`;
